import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContextValue } from "../../context/context";
import { formatDate } from "../../Utils/formatDate/formatDate";

import calendarIcon from "../../assets/calendar-icon.png"
import "./style.css";

export const Calendar = ({ selectedMonth }) => {
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [clickedDay, setClickedDay] = useState(null);
	const { selectedDate, setSelectedDate, setFilledCards, filledCards, orders } = useContextValue();

	// Prevent body scrolling when modal is open
	useEffect(() => {
		if (isPopupOpen) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}

		// Cleanup on unmount
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [isPopupOpen]);
	console.log(orders);

	let navigate = useNavigate();

	const today = new Date();
	const currentYear = new Date().getFullYear();
	const monthToDisplay = selectedMonth !== undefined ? selectedMonth : selectedDate.date.getMonth();

	const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
	const firstDayOfMonth = (month, year) => (new Date(year, month, 1).getDay() + 6) % 7;

	const handleDayClick = (day) => {
		const newDate = new Date(currentYear, monthToDisplay, day);
		const newCard = { date: newDate, isSelected: true, title: "Datum", icon: calendarIcon };
		setSelectedDate(newCard);
		const formattedNewCard = formatDate(newCard);

		// Перевіряємо чи існує картка з таким самим title
		const existingCardIndex = filledCards.findIndex(card => card.title === formattedNewCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = formattedNewCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, formattedNewCard]);
		}
	};

	const handleNewOrderClick = () => {
		if (clickedDay !== null) {
			handleDayClick(clickedDay);
			setIsPopupOpen(false);
		}
	};

	const isSameDate = (date1, date2) => {
		return (
			date1.getFullYear() === date2.getFullYear() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getDate() === date2.getDate()
		);
	};

	const ordersForSelectedDay = orders.filter(order =>
		isSameDate(new Date(order.date), new Date(currentYear, monthToDisplay, clickedDay))
	);


	const renderDaysOfWeek = () => {
		const daysOfWeek = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
		return daysOfWeek.map((day, index) => (
			<div key={index} className="day-name">
				{day}
			</div>
		));
	};

	const renderDays = () => {
		const totalDays = daysInMonth(monthToDisplay, currentYear);
		const startDay = firstDayOfMonth(monthToDisplay, currentYear);

		const calendarDays = [];
		for (let i = 0; i < startDay; i++) {
			calendarDays.push("");
		}

		for (let i = 1; i <= totalDays; i++) {
			calendarDays.push(i);
		}

		while (calendarDays.length < 42) {
			calendarDays.push("");
		}

		return calendarDays.map((day, index) => {
			const isToday =
				day &&
				today.getDate() === day &&
				today.getMonth() === monthToDisplay &&
				today.getFullYear() === currentYear;

			const isSelected =
				day &&
				selectedDate.date.getDate() === day &&
				selectedDate.date.getMonth() === monthToDisplay &&
				selectedDate.date.getFullYear() === currentYear;

			const isWeekend =
				day &&
				(new Date(currentYear, monthToDisplay, day).getDay() === 6 ||
					new Date(currentYear, monthToDisplay, day).getDay() === 0);

			const isEmptyCell = !day;


			if (day) {
				const currentDate = new Date(currentYear, monthToDisplay, day);

				const matchingOrders = orders.filter(order =>
					new Date(order.date).getDate() === currentDate.getDate() &&
					new Date(order.date).getMonth() === currentDate.getMonth() &&
					new Date(order.date).getFullYear() === currentDate.getFullYear()
				);

				const statuses = matchingOrders.map(order => order.status.toLowerCase());

				if (statuses.includes("pending") && statuses.includes("completed")) {
					return (
						<div
							key={index}
							className={`day-cell 
							${isToday ? "today" : ""} 
							${isSelected ? "selected" : ""} 
							${isWeekend ? "weekend" : ""} 
							${isEmptyCell ? "empty" : ""}`}
							onClick={() => {
								if (day && !isWeekend) {
									setClickedDay(day);
									setIsPopupOpen(true);
								}
							}}
						>
							<div className="triangle top-left"></div>
							<div className="triangle bottom-right"></div>
							{day}
						</div>
					);
				}
				if (statuses.includes("pending")) {
					return (
						<div
							key={index}
							className={`day-cell 
							${isToday ? "today" : ""} 
							${isSelected ? "selected" : ""} 
							${isWeekend ? "weekend" : ""} 
							${isEmptyCell ? "empty" : ""}`}
							onClick={() => {
								if (day && !isWeekend) {
									setClickedDay(day);
									setIsPopupOpen(true);
								}
							}}
						>
							<div className="triangle bottom-right"></div>
							{day}
						</div>
					);
				}
				if (statuses.includes("completed")) {
					return (
						<div
							key={index}
							className={`day-cell 
							${isToday ? "today" : ""} 
							${isSelected ? "selected" : ""} 
							${isWeekend ? "weekend" : ""} 
							${isEmptyCell ? "empty" : ""}`}
							onClick={() => {
								if (day && !isWeekend) {
									setClickedDay(day);
									setIsPopupOpen(true);
								}
							}}
						>
							<div className="triangle top-left"></div>
							{day}
						</div>
					);
				}
			}

			return (
				<div
					key={index}
					className={`day-cell 
						${isToday ? "today" : ""} 
						${isSelected ? "selected" : ""} 
						${isWeekend ? "weekend" : ""} 
						${isEmptyCell ? "empty" : ""}`}
					onClick={() => {
						if (day && !isWeekend) {
							setClickedDay(day);
							setIsPopupOpen(true);
						}
					}}
				>
					{day}
				</div>
			);
		});
	};


	return (
		<div className="calendar">
			{/* Рядок із назвами днів */}
			<div className="calendar-dayNames">{renderDaysOfWeek()}</div>
			{/* Дні місяця */}
			<div className="calendar-content">
				<div className="calendar-days">{renderDays()}</div>
			</div>
			{isPopupOpen && (
				<div className="popup-overlay" onClick={() => setIsPopupOpen(false)}>
					<div className="popup" onClick={(e) => e.stopPropagation()}>
						<div className="popup-content">
							{ordersForSelectedDay.length > 0 ? (
								<ul className="popup-order-list">
									{ordersForSelectedDay.map((order, index) => (
										<li className="popup-order-item" key={index} onClick={() => navigate("/translator")}>
											<span>{order.id}</span>
											<span>{order.status}</span>
											<span>time remaining: 00 00</span>
										</li>
									))}
								</ul>
							) : (
								<p>Für diesen Tag liegen noch keine Bestellungen vor.</p>
							)}
						</div>
						<div className="popup-buttons">
							<button onClick={handleNewOrderClick}>Neue Anfrage</button>
							<button onClick={() => setIsPopupOpen(false)}>Fenster Schließen</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
